import { useMemo } from 'react'
import styled from 'styled-components'
import FlightSortingBar from 'components/Flights/FlightSorting/FlightSortingBar'
import type { FlightSortOptions } from 'constants/flight'
import { getFlightV2SortOptionValues } from 'lib/flights/flightUtils'
import { useAssistantSurfaceDropdownBoundary } from 'tripPlanner/assistant/layout/AssistantSurfaceLayoutContext'
import { flightResultsWide } from './flightResultsLayout'

const SortingBar = styled.div`
  display: none;

  ${flightResultsWide} {
    display: block;
  }
`

interface Props {
  journeys: Array<App.JourneyV2>
  sort: FlightSortOptions
  originAirportCode?: string
  destinationAirportCode?: string
  onChange: (sort: FlightSortOptions) => void
}

function ChatFlightSortingBar({ journeys, sort, originAirportCode = '', destinationAirportCode = '', onChange }: Props) {
  const optionValues = useMemo(() => getFlightV2SortOptionValues(journeys), [journeys])
  const dropdownBoundary = useAssistantSurfaceDropdownBoundary()

  return (
    <SortingBar>
      <FlightSortingBar
        sort={sort}
        originAirportCode={originAirportCode}
        destinationAirportCode={destinationAirportCode}
        onChange={onChange}
        optionValues={optionValues}
        dropdownBoundaryRef={dropdownBoundary.boundaryRef}
        dropdownPortaled={dropdownBoundary.portaled ?? true}
        dropdownAutoHeight={dropdownBoundary.autoHeight}
      />
    </SortingBar>
  )
}

export default ChatFlightSortingBar
